import React from 'react'
import {
  ErrorToast,
  ErrorToastIcon,
  ErrorToastBody,
} from './LoyaltySignInModal.css'

// Material-style "error_outline" — uicomponents doesn't ship one.
const ErrorOutlineIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="10" cy="10" r="9" stroke="#cc3333" strokeWidth="2" />
    <line x1="10" y1="5.5" x2="10" y2="11.5" stroke="#cc3333" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10" cy="14.25" r="1" fill="#cc3333" />
  </svg>
)

const RECOVER_PASSWORD_URL = '/myaccount/login?forgotpassword=true'

type LoyaltyErrorToastProps = {
  message: string
  // Set false on errors where "Recover Password" doesn't make sense as a CTA.
  // Defaults to true — the two cases this toast handles today (email-already-
  // registered on create-account, invalid-credentials on sign-in) both benefit
  // from the link.
  showRecoverLink?: boolean
}

const LoyaltyErrorToast: React.FC<LoyaltyErrorToastProps> = ({
  message,
  showRecoverLink = true,
}) => (
  <ErrorToast role="alert">
    <ErrorToastIcon>
      <ErrorOutlineIcon />
    </ErrorToastIcon>
    <ErrorToastBody>
      {message}
      {showRecoverLink && (
        <>
          <br />
          <a href={RECOVER_PASSWORD_URL}>Recover Password</a>
        </>
      )}
    </ErrorToastBody>
  </ErrorToast>
)

export default LoyaltyErrorToast
